export default __webpack_public_path__ + "static/media/mc-logo-wide-white.799dde99.svg";